// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"500":"modal-connect-wallet","810":"modal-buy-now"}[chunkId] || chunkId) + "." + {"470":"3b7193d6","500":"0a831a99","787":"305c6cb4","810":"3d8464dc"}[chunkId] + ".chunk.js";
};